export const reducer = ((prevData, action) => {
  const transcript = {...prevData };
  const {id, text, speaker } = action;

  switch(action.type) {
    case 'initial':
      transcript.paragraphs = action.paragraphs
      const startTimes = transcript.paragraphs.map(({start}) => start)
      return { ...transcript, startTimes}
    case 'update_paragraph':
      transcript.paragraphs[id]["text"] = text;
      return {...transcript, paragraphs: transcript.paragraphs}
    case 'update_speaker':
      transcript.paragraphs[id]["speaker"] = speaker;
      return {...transcript, paragraphs: transcript.paragraphs}
    case 'update_all_speaker':
      const existingSpeakerName = transcript.paragraphs[id]["speaker"]
      const n = transcript.paragraphs.length;

      for(let i = 0; i < n; i++) {
        if(transcript.paragraphs[i]["speaker"] === existingSpeakerName) {
          transcript.paragraphs[i]["speaker"] = speaker;
        }
      }
      return {...transcript, paragraphs: transcript.paragraphs}
  }

  return transcript
})